module.exports = __webpack_public_path__ + "static/family_photo-9d83c9b05d5e7e7956aaf98b50ce1562.jpg";